import React from 'react';
import R from 'ramda';
import PropTypes from 'prop-types';
import Link from '@cotyorg/ccx-atoms/Link';

const ShopNow = ({
  useBuyNowWidget,
  eventHandler,
  selectedProduct,
  selectedProductSwatch,
  vto,
  handleChannelAdvisor,
  useBuyNowRetailer,
}) => {
  if (useBuyNowWidget) {
    return (
      <span
        className="vto__button-shop-now"
        aria-hidden="true"
        onClick={() => {
          eventHandler({
            eventName: 'vto-product-event-shop-now',
          });
          handleChannelAdvisor();
        }}
      >
        {R.path(['buyNowButton', 'text'], vto)}
      </span>
    );
  }

  if (useBuyNowRetailer) {
    return (
      <>
        {R.prop('url', selectedProductSwatch) && (
          <Link
            onClick={() =>
              eventHandler({
                eventName: 'vto-product-event-shop-now',
              })
            }
            target="_blank"
            link={R.prop('url', selectedProductSwatch)}
          >
            {R.path(['buyNowButton', 'text'], vto)}
          </Link>
        )}
      </>
    );
  }

  return (
    <Link
      onClick={() =>
        eventHandler({
          eventName: 'vto-product-event-shop-now',
        })
      }
      target="_blank"
      link={`${R.prop(
        'productUrl',
        selectedProduct
      )}?shade=${encodeURIComponent(
        R.prop('itemName', selectedProductSwatch)
      )}#buy-now`}
    >
      {R.path(['buyNowButton', 'text'], vto)}
    </Link>
  );
};

ShopNow.propTypes = {
  selectedProduct: PropTypes.object,
  selectedProductSwatch: PropTypes.object,
  vto: PropTypes.shape({
    button: PropTypes.shape({
      text: PropTypes.string,
      iconUrl: PropTypes.string,
    }),
    buyNowButton: PropTypes.shape({
      text: PropTypes.string,
    }),
    vtoSourceUrl: PropTypes.string.isRequired,
    actualProductSku: PropTypes.string,
    actualProductSlug: PropTypes.string,
    vtoScriptLoaded: PropTypes.bool,
    products: PropTypes.arrayOf(
      PropTypes.shape({
        slug: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        variants: PropTypes.arrayOf(PropTypes.object),
      })
    ),
  }),
  useBuyNowWidget: PropTypes.bool,
  eventHandler: PropTypes.func,
  handleChannelAdvisor: PropTypes.func,
  useBuyNowRetailer: PropTypes.bool,
};

export default ShopNow;
